import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';

export const usePickListTemplatesFeatureGate = () => usePlanFeatureGate(Features.PickListTemplates);
